
import {
  SlaResponse,
  EffortResponse,
  DocumentationResponse,
  CaseloadResponse,
  TaskLoadResponse,
  ParticipantActivityResponse,
  TagsResponse,
} from "../../interfaces/analytics";

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/analytics`;

type AnalyticsApiParams = {
  startDate?: string;
  endDate?: string;
  taskSubTypeId?: number[];
  teamId?: string;
  scId?: string;
  regionId?: string;
  interval?: "day" | "week" | "month";
  includeCanceled?: boolean;
  includeSystemActions?: boolean;
  asOf?: string;
  staleDays?: number;
  tagId?: number[];
};

const buildQueryParams = (params: AnalyticsApiParams): string => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(key, v.toString()));
      } else {
        queryParams.append(key, value.toString());
      }
    }
  });
  return queryParams.toString();
};

const fetchAnalyticsData = async <T>(
  endpoint: string,
  authToken: string,
  params: AnalyticsApiParams
): Promise<T | null> => {
  try {
    const queryParams = buildQueryParams(params);
    const url = `${API_BASE_URL}${endpoint}?${queryParams}`;
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error(`Error fetching ${endpoint}:`, response.statusText);
      return null;
    }
    const responseData = await response.json();
    console.log('ResponseData', responseData);
    return responseData
  } catch (error) {
    console.error(`Error in fetchAnalyticsData for ${endpoint}:`, error);
    return null;
  }
};

export const getSla = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<SlaResponse | null> => {
  return fetchAnalyticsData<SlaResponse>("/sla", authToken, params);
};

export const getEffort = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<EffortResponse | null> => {
  return fetchAnalyticsData<EffortResponse>("/effort", authToken, params);
};

export const getDocumentation = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<DocumentationResponse | null> => {
  return fetchAnalyticsData<DocumentationResponse>(
    "/documentation",
    authToken,
    params
  );
};

export const getCaseload = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<CaseloadResponse | null> => {
  return fetchAnalyticsData<CaseloadResponse>("/caseload", authToken, params);
};

export const getTaskLoad = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<TaskLoadResponse | null> => {
  return fetchAnalyticsData<TaskLoadResponse>("/task-load", authToken, params);
};

export const getParticipantActivity = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<ParticipantActivityResponse | null> => {
  return fetchAnalyticsData<ParticipantActivityResponse>(
    "/participants/activity",
    authToken,
    params
  );
};

export const getTags = (
  authToken: string,
  params: AnalyticsApiParams
): Promise<TagsResponse | null> => {
  return fetchAnalyticsData<TagsResponse>("/tags", authToken, params);
};
